import CriteresExport from './CriteresExport';
import Export from './Export';
import MesExports from './MesExports';

export default {
  install(Vue) {
    Vue.component('criteresExport', CriteresExport);
    Vue.component('export', Export);
    Vue.component('mesExports', MesExports);
  },
};
